import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button
} from "@material-ui/core";
import parse from "html-react-parser";

import PropTypes from "prop-types";
import styles from "./styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const FaqAccordion = ({ question, expanded, handleChange }) => {
  const classes = styles();

  return (
    <Accordion
      expanded={expanded === `panel${question.id}`}
      onChange={handleChange(`panel${question.id}`)}
      className={classes.contenedorTab}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={classes.titleTab}
      >
        <div>{parse(question.title || "")}</div>
      </AccordionSummary>
      <AccordionDetails className={classes.detailTab}>
        <div className={classes.descriptionTab}>
          {parse(question.description || "")}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};
FaqAccordion.propTypes = {
  question: PropTypes.object,
  expanded: PropTypes.any,
  handleChange: PropTypes.any
};
export default FaqAccordion;
